/* eslint-disable import/prefer-default-export */
import { createSelector } from '@reduxjs/toolkit';
import { KubernetesClusterState, clusterAdapter } from 'components/pages/console/store/KubernetesClusterSlice';
import KubernetesClusterObject from 'gql/KubernetesCluster';
import { ActionStatus } from 'store/ActionState';
import { RootState } from 'store/RootReducer';

const selectSelf = (state: RootState): KubernetesClusterState => {
  return state.cluster;
};

const selectFetchCluster = createSelector(
  selectSelf,
  (state: KubernetesClusterState): KubernetesClusterObject | undefined => {
    return state.kubernetesCluster ? state.kubernetesCluster : undefined;
  }
);

const selectFetchClusterState = createSelector(selectSelf, (state: KubernetesClusterState): ActionStatus => {
  return state.fetchClusterState.status;
});

const selectFetchClustersState = createSelector(selectSelf, (state: KubernetesClusterState): ActionStatus => {
  return state.fetchClustersState.status;
});

const selectAll = createSelector(selectSelf, (state: KubernetesClusterState): KubernetesClusterObject[] => {
  return state.kubernetesClusters ? clusterAdapter.getSelectors().selectAll(state.kubernetesClusters) : [];
});

const KubernetesClusterSelectors = {
  selectFetchCluster,
  selectFetchClusterState,
  selectFetchClustersState,
  selectAll,
};

export default KubernetesClusterSelectors;
